import { render } from "./UploadLearning.vue?vue&type=template&id=1478a838&scoped=true"
import script from "./UploadLearning.vue?vue&type=script&lang=js"
export * from "./UploadLearning.vue?vue&type=script&lang=js"

import "./UploadLearning.vue?vue&type=style&index=0&id=1478a838&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1478a838"]])

export default __exports__